<template>
  <div id="about" class="position-relative" ref="index">
    <div class="wrap">
      <div class="container">
        <!-- 時間軸 -->
        <section class="timeline">
          <!-- 標題 -->
          <div
            class="title"
            data-aos="zoom-in"
            data-aos-anchor="#header"
            data-aos-anchor-placement="top-center"
            data-aos-once="true"
          >
            <h1 class="h2 text-center text-white py-30">奇蹟之家沿革</h1>
            <!-- 副標題 -->
            <div class="subtitle d-flex justify-content-around mx-auto mt-20">
              <div class="circle d-flex justify-content-center align-items-center">
                <h4 class="text-white m-0">時</h4>
              </div>
              <div class="circle d-flex justify-content-center align-items-center">
                <h4 class="text-white m-0">間</h4>
              </div>
              <div class="circle d-flex justify-content-center align-items-center">
                <h4 class="text-white m-0">表</h4>
              </div>
            </div>
          </div>
          <!-- 時間區段 -->
          <div class="part mx-auto">
            <ul id="time-line" class="d-flex flex-column">
              <li
                v-for="(item, index) in timeline"
                :key="index"
                class="row"
                data-aos="fade-up"
                data-aos-once="true"
              >
                <div class="line-col col-2 d-none d-sm-block">
                  <div class="line h-100"></div>
                </div>
                <div class="point-col col-1">
                  <div class="point"></div>
                </div>
                <div class="text-col col-9">
                  <h5 class="text-primary">{{ item.title }}</h5>
                  <p class="text m-0" v-html="item.desc"></p>
                </div>
              </li>
            </ul>
          </div>
          <!-- 教堂 -->
          <div
            class="church d-flex mt-2 position-relative"
            data-aos="zoom-out-up"
            data-aos-once="true"
          >
            <img class="mx-auto" src="@/assets/images/church.svg" />
          </div>
        </section>
      </div>
    </div>
    <!-- 介紹文章 -->
    <section class="article">
      <div class="container py-50">
        <div class="d-flex align-items-center justify-content-center w-75 mx-auto">
          <p v-if="article.length>0" v-html="article[0].content" />
          <p v-else>關於我們</p>
        </div>
      </div>
    </section>
    <!-- 環境介紹 -->
    <section class="environment bg-secondary-white" ref="environment">
      <div :class="{'container':screenWidth>=992}">
        <hooper
          class="h-100"
          :wheelControl="false"
          :keysControl="false"
          :infiniteScroll="true"
          :playSpeed="10000"
          :autoPlay="true"
        >
          <slide
            v-for="(item, index) in photo"
            :key="index"
            class="d-flex align-items-center justify-content-center"
          >
            <img v-lazy="item.thumb" :key="item.id" class="img-fluid" />
          </slide>
          <hooper-navigation slot="hooper-addons"></hooper-navigation>
          <hooper-pagination slot="hooper-addons"></hooper-pagination>
        </hooper>
      </div>
    </section>
    <div class="back d-flex align-items-center justify-content-center" @click="scrollToTop">
      <i class="material-icons">expand_less</i>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation,
  Pagination as HooperPagination,
} from 'hooper';

export default {
  name: 'aboutUs',
  metaInfo: {
    title: ' - 關於我們',
  },
  components: {
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination,
  },
  computed: { ...mapGetters(['screenWidth']) },
  data() {
    return {
      kv_id: 11,
      article_id: 14,
      timeline: [
        {
          title: '2020年',
          desc: '修院在中國100週年慶',
        },
        {
          title: '2018年01月',
          desc: '立案為財團法人天主教主顧修女會附設新北市泰山奇蹟之家綜合長照機構',
        },
        {
          title: '2017年11月',
          desc: '成立奇蹟照顧咖啡館',
        },
        {
          title: '2017年08月',
          desc: '擴編日間照顧服務，從服務32人增加至56人',
        },
        {
          title: '2017年07月',
          desc: '成立社區整體照顧服務中心',
        },
        {
          title: '2017年03月',
          desc: '增加日間照顧沐浴服務',
        },
        {
          title: '2014年07月',
          desc: '擴編日間照顧服務，從服務24人增加至32人',
        },
        {
          title: '2013年01月',
          desc: '提供居家喘息服務',
        },
        {
          title: '2010年12月',
          desc: '提供日間照顧服務',
        },
        {
          title: '2009年08月',
          desc: '開辦瑞智學堂',
        },
        {
          title: '2007年07月',
          desc: '提供下午休閒服務',
        },
        {
          title: '2006年09月',
          desc: '成立社區關懷據點',
        },
        {
          title: '2004年09月',
          desc: '開辦銀髮族趣味生活教室戶外健康促進活動',
        },
        {
          title: '2003年09月',
          desc: '提供居家服務，開辦聖經與生活分享團體',
        },
        {
          title: '2003年08月',
          desc: '提供老人營養餐飲服務',
        },
        {
          title: '2002年09月',
          desc: '辦理鄉民大學的課程',
        },
        {
          title: '2001年04月',
          desc: '成立社區學習型社區-從事電話問安及居家關懷訪視',
        },
        {
          title: '2000年10月',
          desc: '馬玉潔修女開始奇蹟之家的服務',
        },
        {
          title: '1972年6月',
          desc: '主顧會在新北市泰山興建現有的會院',
        },
        {
          title: '1956年1月',
          desc: '成立財團法人天主教主顧修女會並創辦靜宜女子文理學院',
        },
        {
          title: '1948年12月',
          desc: '蓋夏姆姆帶領修女們到達台灣，繼續從事福傳、教育及社會服務。',
        },
        {
          title: '1920年11月',
          desc: '蓋夏姆姆被派遣從美國帶領5名修女到達中國開封，從事福傳、教育及社會服務。',
        },
        {
          title: '1840年10月',
          desc: '聖狄奧多姆姆被派遣從法國帶領5位修女抵達美國印第安那州，從事福傳、教育及社會服務。',
        },
      ],
      photo: [],
      article: {},
    };
  },
  methods: {
    getPhoto() {
      const url = `/banner/${this.kv_id}`;
      this.axios
        .get(url)
        .then((response) => {
          this.photo = response.data.data.file.data;
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
        });
    },
    getArticle() {
      const url = '/article';
      const params = {
        search: this.article_id,
        searchFields: 'category_id',
        orderBy: 'publish_at',
        sortedBy: 'desc',
      };
      this.axios
        .get(url, { params })
        .then((response) => {
          this.article = response.data.data;
          this.article.forEach((item) => {
            if (item.content.match(/^pre/g) !== undefined) {
              item.content = item.content.replace(new RegExp('pre>', 'ig'), 'div>');
            }
          });
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
        });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    this.getPhoto();
    this.getArticle();
    if (this.$route.params.id) {
      const target = this.$route.params.id;
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs[target].scrollIntoView();
        }, 800);
      });
    } else {
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollToTop();
        }, 500);
      });
    }
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/all.scss';

#about {
  .wrap {
    background-image: url('~@/assets/images/cloud-blue2.svg');
    background-size: auto 150px;
    background-repeat: no-repeat;
    background-position: center top;
    background-color: lighten($sub-primary-white, 2%);
    @media (min-width: 768px) {
      background-image: url('~@/assets/images/cloud-blue2.svg'),
        url('~@/assets/images/cloud-blue.svg'), url('~@/assets/images/cloud-green.svg');
      background-size: auto 200px, auto 170px, auto 170px;
      background-repeat: no-repeat;
      background-position: center top, left bottom, right bottom;
      background-color: lighten($sub-primary-white, 2%);
    }
    @media (min-width: 992px) {
      background-image: url('~@/assets/images/cloud-blue.svg'),
        url('~@/assets/images/cloud-green.svg'), url('~@/assets/images/bg-circle-left.svg'),
        url('~@/assets/images/bg-circle-right.svg');
      background-size: auto 170px, auto 170px, 170px auto, 170px auto;
      background-repeat: no-repeat, no-repeat, repeat-y, repeat-y;
      background-position: left bottom, right bottom, left top, right top;
      background-color: lighten($sub-primary-white, 2%);
    }
  }
  section {
    &:not(.timeline):not(.environment):not(.hooper) {
      padding: 20px 0;
      @media (min-width: 576px) {
        padding: 80px 0;
      }
    }
    &.timeline {
      // 標題
      .title {
        width: 100%;
        height: 200px;
        @media (min-width: 768px) {
          background-image: url('~@/assets/images/cloud-blue2.svg');
        }
        background-size: auto 100%;
        background-repeat: no-repeat;
        background-position: center top;
        h1 {
          letter-spacing: 10px;
        }
        // 副標題
        .subtitle {
          width: 100%;
          @media (min-width: 768px) {
            width: 30%;
          }
          .circle {
            width: 45px;
            height: 45px;
            border-radius: 50%;
            background: $primary;
          }
        }
      }
      // 時間區段
      .part {
        ul {
          list-style: none;
          margin: 0;
          padding: 0;
          p {
            margin: 0;
          }
          li {
            width: 100%;
            @media (min-width: 576px) {
              width: 50%;
            }
            .point-col {
              padding: 0;
              position: relative;
              .point {
                width: 15px;
                height: 15px;
                box-sizing: border-box;
                background-color: #fff;
                border: 3px solid $sub-primary;
                border-radius: 50%;
                margin-top: 22px;
                margin-left: auto;
                @media (min-width: 576px) {
                  margin-left: 0;
                }
              }
              &::before {
                content: '';
                position: absolute;
                top: 35px;
                right: 17%;
                bottom: -15px;
                border-radius: 5px;
                width: 5px;
                z-index: 10;
                background: $sub-primary;
                @media (min-width: 576px) {
                  display: none;
                }
              }
            }
            .line-col {
              padding: 27px 0 0 0;
              .line {
                border-top: solid 3px $sub-primary;
                margin-bottom: -8px;
              }
            }
            .text-col {
              padding-top: 10px;
              padding-bottom: 10px;
              .text-time {
                letter-spacing: 2px;
              }
              .text {
                font-size: 16px;
                min-height: 30px;
                letter-spacing: 2px;
                line-height: 28px;
                font-weight: normal;
              }
            }
          }
          @media (min-width: 576px) {
            li:nth-child(odd) {
              margin-right: auto;
              text-align: right;
              .point-col {
                order: 2;
              }
              .line-col {
                order: 3;
                .line {
                  border-right: solid 3px $sub-primary;
                  margin-right: -17px;
                  margin-left: -30px;
                }
              }
              .text-col {
                padding-left: 30px;
              }
            }
            li:nth-child(even) {
              margin-left: auto;
              .point-col {
                padding-right: 0;
                .point {
                  margin-left: auto;
                }
              }
              .line-col {
                .line {
                  border-left: solid 3px $sub-primary;
                  margin-left: -18px;
                  margin-right: -30px;
                }
              }
              .text-col {
                padding-right: 30px;
              }
            }
          }
        }
      }
      .church {
        position: relative;
        width: 100%;
        height: 330px;
        margin-bottom: -20px;
        z-index: 10;
        img {
          width: 90%;
          height: auto;
          @media (min-width: 576px) {
            height: 100%;
            width: auto;
          }
        }
      }
    }
    &.article {
      background-image: url('~@/assets/images/cloud-blue.svg');
      background-size: auto 150px;
      background-repeat: no-repeat;
      background-position: left bottom;
      background-color: lighten($sub-primary-white, 2%);
      @media (min-width: 768px) {
        background-image: none;
      }
      p {
        font-size: 16px;
        letter-spacing: 2px;
        line-height: 2em;
      }
    }
    &.environment {
      padding-bottom: 25px;
      overflow: hidden;
      min-height: auto;
      @media (min-width: 576px) {
        min-height: 400px;
      }
      @media (min-width: 768px) {
        padding: 0;
      }
      .hooper {
        width: 100%;
        height: 100%;
      }
      .hooper-slide {
        position: relative;
        // height: 100%;
        img {
          width: 100%;
          max-height: 650px;
        }
      }
      .hooper-navigation {
        button {
          background: rgba(0, 0, 0, 0.5);
        }
        svg {
          path:nth-of-type(2) {
            fill: white;
          }
        }
      }
    }
  }
  .back {
    bottom: -30px;
    @media (min-width: 768px) {
      bottom: 10%;
    }
  }
}
</style>
